import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import BottomNav from "./components/layout/BottomNav";
import { useTelegram } from "./hooks/useTelegram";
import { useTheme } from "./hooks/useTheme";
import CreateBot from "./pages/CreateBot";
import Dashboard from "./pages/Dashboard";
import MyBots from "./pages/MyBots";
import Pricing from "./pages/Pricing";
import Referral from "./pages/Referral";

export default function App() {
  const [active, setActive] = useState("home");
  const telegram = useTelegram();
  useTheme(telegram.tg);
  const pages = {
    home: <Dashboard user={telegram.user} setActive={setActive} />,
    bots: <MyBots />,
    create: <CreateBot tg={telegram.tg} />,
    plans: <Pricing showToast={telegram.showToast} />,
    profile: <Referral user={telegram.user} showToast={telegram.showToast} />
  };
  return <div className="app-safe"><AnimatePresence mode="wait"><motion.div key={active} initial={{ opacity: 0, x: 10 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -10 }}>{pages[active]}</motion.div></AnimatePresence><BottomNav active={active} setActive={setActive} /></div>;
}
